/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Code_ThrottledInputs */

const id_staff_code_throttled = /** @type {(inputs: Staff_Code_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlalu banyak percobaan. Tunggu sebentar, lalu coba lagi.`)
};

const en_staff_code_throttled = /** @type {(inputs: Staff_Code_ThrottledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Wait a moment, then try again.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Wait a moment, then try again." |
*
* @param {Staff_Code_ThrottledInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_code_throttled = /** @type {((inputs?: Staff_Code_ThrottledInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Code_ThrottledInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_code_throttled(inputs)
	return id_staff_code_throttled(inputs)
});